import { privacyDraft, privacyPayload } from "@/Utile/ncrmExternalFormPrivacy.mjs";

// GDPR S5.3B (`GDPR-085`) — formularul public „Colectare date”: email și/sau telefon,
// Nume opțional și câte o bifă de consimțământ pe fiecare câmp de contact, fiecare cu
// maparea Privacy proprie (`consent_json.privacy_fields`). Serverul rămâne arbitrul:
// valorile de aici sunt numai forma editabilă din drawer.
export const DATA_COLLECTION_LOCALES = Object.freeze(["ro", "en", "ru"]);
export const DATA_COLLECTION_CONTACT_FIELDS = Object.freeze(["email", "phone"]);
export const DEFAULT_DATA_COLLECTION_FIELDS = Object.freeze({ name: true, email: true, phone: false });
// Aceleași texte ca `DEFAULT_DATA_COLLECTION_CONTENT` din backend (test de paritate):
// adminul vede și aprobă exact textul pe care îl va vedea vizitatorul.
export const DEFAULT_DATA_COLLECTION_CONTENT = Object.freeze({
  ro: Object.freeze({
    title: "Rămâi în legătură cu noi",
    description: "Lasă-ne datele de contact și alege cum vrei să comunicăm. Le folosim numai pentru scopurile bifate mai jos.",
  }),
  en: Object.freeze({
    title: "Stay in touch with us",
    description: "Leave your contact details and choose how we may reach you. We use them only for the purposes ticked below.",
  }),
  ru: Object.freeze({
    title: "Оставайтесь на связи",
    description: "Оставьте контактные данные и выберите, как с вами связываться. Мы используем их только для отмеченных ниже целей.",
  }),
});

// Draftul editabil: câmpurile lipsă primesc valorile implicite ale serverului, iar
// fiecare câmp de contact are o mapare (goală, dacă nu e configurată).
export const dataCollectionFieldsDraft = (value) => Object.fromEntries(
  Object.entries(DEFAULT_DATA_COLLECTION_FIELDS)
    .map(([key, fallback]) => [key, typeof value?.[key] === "boolean" ? value[key] : fallback])
);

// Textele lipsă sau goale pornesc de la cele implicite, ca serverul: editorul nu
// arată niciodată un câmp gol care s-ar salva ca alt text.
export const dataCollectionLocalesDraft = (value) => Object.fromEntries(DATA_COLLECTION_LOCALES.map((locale) => [
  locale,
  {
    title: String(value?.[locale]?.title || "").trim() || DEFAULT_DATA_COLLECTION_CONTENT[locale].title,
    description: String(value?.[locale]?.description || "").trim() || DEFAULT_DATA_COLLECTION_CONTENT[locale].description,
  },
]));

export const privacyFieldsDraft = (value) => Object.fromEntries(
  DATA_COLLECTION_CONTACT_FIELDS.map((field) => [field, privacyDraft(value?.[field])])
);

// Payloadul: numai mapările utile; fără niciuna, `null` elimină configul stocat.
export const privacyFieldsPayload = (draft) => {
  const mapped = Object.fromEntries(DATA_COLLECTION_CONTACT_FIELDS
    .map((field) => [field, privacyPayload(draft?.[field])])
    .filter(([, privacy]) => privacy));
  return Object.keys(mapped).length ? mapped : null;
};

export const enabledContactFields = (fields) =>
  DATA_COLLECTION_CONTACT_FIELDS.filter((field) => Boolean(fields?.[field]));
